module.exports = __webpack_public_path__ + "assets/img/title.124762f3.png";